import { Injectable, NgModule } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HTTP_INTERCEPTORS } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';

@Injectable()
export class ClientInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      const clientID = environment.clientID;
      const changeReq = req.clone({
          params: req.params.append('client_id', clientID)
      });
      return next.handle(changeReq);
  }
}

@NgModule({
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ClientInterceptor,
            multi: true,
        },
    ],
})  
export class Interceptor {}


// WEBPACK FOOTER //
// ./src/app/@core/interceptors/client-interceptor.ts